import { request } from '../services/request';
import { bind } from '@react-rxjs/core';
import { createSignal } from '@react-rxjs/utils';
import { catchError, concat, EMPTY, map, of, shareReplay, switchMap, take, tap } from 'rxjs';
import memoizee from 'memoizee';

const DEFAULT_LANGUAGE_CODE = 'en_GB';
const STORAGE_KEY = 'language';

export const [useLanguages, languages$] = bind(
  request<{ code: string; language: string }[]>(`/i18n/languages/`).pipe(
    map((languages) => languages.map(({ code, language }) => ({ code, language }))),
    shareReplay(1)
  )
);

export const detect$ = languages$.pipe(
  switchMap((languages) =>
    of(
      languages.find(({ code }: any) =>
        code.match((localStorage.getItem(STORAGE_KEY) ?? navigator.language).slice(0, 2).toLowerCase())
      )?.code ?? DEFAULT_LANGUAGE_CODE
    )
  ),
  catchError(() => EMPTY),
  take(1)
);

export const [language$, setLanguage] = createSignal<string>();
export const [useLanguage, languageChanged$] = bind<string>(concat(detect$, language$));

export const fetchTranslations = memoizee(
  (locale: string) => request<Record<string, string>>(`/i18n/translations/${locale}/`).pipe(shareReplay(1)),
  { primitive: true, promise: true }
);

export const [useTranslations] = bind(
  languageChanged$.pipe(
    tap((language) => localStorage.setItem(STORAGE_KEY, language)),
    switchMap((language) => fetchTranslations(language).pipe(catchError(() => EMPTY)))
  )
);
